import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  min-width: 100vw;
  min-height: 100vh;
  background: #e4ebeb;
  section {
    justify-self: center;
    margin: 23% auto;
  }
`;
